import commonApi from './CommonApi.js';

export default {
	adminGetAll: async (parameter) => {
		return await commonApi().get('/v1/otherDocuments/admin', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	adminGetById: async (parameters) => {
		return await commonApi().get('/v1/otherDocuments/admin/getById', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	edit: async (viewModel) => {
		return await commonApi().put('/v1/otherDocuments/admin/', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	search: async (parameter) => {
		return await commonApi().get('/v1/otherDocuments/search', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getViewDocument: async (parameter) => {
		return await commonApi().get('/v1/otherDocuments/getViewDocument', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					return null;
				}
			})
			.catch((error) => {
				// 404 => document not found / restricted / no DOL link: open nothing, no error UI.
				if (!error.response || error.response.status !== 404) {
					console.log(error);
				}
				return null;
			});
	},
	download: async (parameter) => {
		return await commonApi().get('/v1/otherDocuments/download', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
}